import { render, staticRenderFns } from "./BetPopsix.vue?vue&type=template&id=0baeb78d&scoped=true&"
import script from "./BetPopsix.vue?vue&type=script&lang=js&"
export * from "./BetPopsix.vue?vue&type=script&lang=js&"
import style0 from "./BetPopsix.vue?vue&type=style&index=0&id=0baeb78d&prod&lang=less&"
import style1 from "./BetPopsix.vue?vue&type=style&index=1&id=0baeb78d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baeb78d",
  null
  
)

export default component.exports